import AlertMenuItem from './alertMenuItem'

export default AlertMenuItem;